export default __webpack_public_path__ + "static/media/note.a7470228.svg";